







































































































































































































































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { mapState } from "vuex";
import { BNavItemDropdown, BDropdownItem, BPopover } from "bootstrap-vue";

@Component({
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BPopover,
  },
  //computed: mapState("auth", ["user"]),
  computed: {
    ...mapState("auth", ["user", "entityId"]),
    ...mapState("schedule", ["waitingList"]),
  },
})
export default class Header extends Vue {
  waitingList!: any;
  entityId!: number;
  logout() {
    this.$store.dispatch("auth/logout");
    this.$router.push({ name: "login" });
  }

  getReportLinks(category, module) {
    if (
      this.$store.state.auth.user.settings[
        "ENABLE_REPORT_ADMIN_ACCESS_" + module.toUpperCase() + "_MODULE"
      ]
    ) {
      return this.$store.state.gaps.reportLinks.filter(
        (r) => r.category === category && r.module === module
      );
    } else if (
      this.$store.state.auth.user.settings[
        "ENABLE_REPORT_ACCESS_" + module.toUpperCase() + "_MODULE"
      ]
    ) {
      return this.$store.state.gaps.reportLinks.filter(
        (r) =>
          r.category === category && r.module === module && r.admin === false
      );
    }
    return [];
  }

  getReportLinkCategories(module) {
    if (
      this.$store.state.auth.user.settings[
        "ENABLE_REPORT_ADMIN_ACCESS_" + module.toUpperCase() + "_MODULE"
      ]
    ) {
      return this.$store.state.gaps.reportLinks
        .filter((r) => r.module === module)
        .map((r) => r.category)
        .filter((v, i, a) => a.indexOf(v) === i);
    } else if (
      this.$store.state.auth.user.settings[
        "ENABLE_REPORT_ACCESS_" + module.toUpperCase() + "_MODULE"
      ]
    ) {
      return this.$store.state.gaps.reportLinks
        .filter((r) => r.module === module && r.admin === false)
        .map((r) => r.category)
        .filter((v, i, a) => a.indexOf(v) === i);
    }
    return [];
  }



  removeSpaces(values) {
    return values.replace(/ /g, "");
  }

  setReportLink(link) {
    this.$store.state.gaps.reportLink = link;
    //this.$root.$emit("bv::hide::popover", "cases-menu-target");
    this.$root.$emit("bv::hide::popover");
  }
  setNonMenuList() {
    this.$root.$emit("bv::hide::popover");
  }
  getDashBoard(entity,module){
    return this.$store.state.gaps.reportLinks.filter(s=>s.entityId == entity && s.module == module).length ? true : false;
  }
  buttonTargetSchedule() {
    return this.$refs.schedule;
  }
  buttonTargetGaps() {
    return this.$refs.gaps;
  }
  buttonTargetCases() {
    return this.$refs.cases;
  }
  buttonTargetAnalytics(){
    return this.$refs.analytics;
  }
  togglePopover(){
    this.$root.$emit("bv::hide::popover");
  }
  showMenuPopover(module){
    let showMenu = this.getDashBoard(this.entityId, module);
    return showMenu == true ? 'click' : 'manual';
  }
  setModuleDashBoard(module,id){
     let entity = this.getDashBoard(this.entityId, module);
     if(entity){
        if(id == 'gaps-menu-target'){
          this.$root.$emit("bv::hide::popover");
          this.$nextTick(() => {
            this.$root.$emit("bv::show::popover", id);
          });
        }else if(id == 'schedule-menu-target'){
          this.$root.$emit("bv::hide::popover");
          this.$nextTick(() => {
            this.$root.$emit("bv::show::popover", id);
          });
        }else if(id == 'cases-menu-target'){
          this.$root.$emit("bv::hide::popover");
          this.$nextTick(() => {
            this.$root.$emit("bv::show::popover", id);
          });
        }else if(id == 'analytics-menu-target'){
          this.$root.$emit("bv::hide::popover");
          this.$nextTick(() => {
            this.$root.$emit("bv::show::popover", id);
          });
        }else{
          this.$root.$emit("bv::hide::popover");
        }
     }else if(!entity){
       if(module == 'GAPS'){
        this.$router.push({ name: 'gap-dashboard' });
       }
       if(module == 'SCHEDULE'){
        this.$router.push({ name: 'schedule' });
       }
       if(module == 'CASES'){
        this.$router.push({ name: 'cases' });
       }
       if(module == 'ANALYTICS'){
        this.$router.push({ name: 'report-message-summary' });
       }
     }
     
  }
  setCheckinList(list) {
    this.$store.state.schedule.checkingList = list;
    this.$root.$emit("bv::hide::popover");
  }

  mounted(){
    this.$store.dispatch("schedule/getWaitingList");
  }

}
